(function () {
  'use strict';

  var pendingSizingFixes = new WeakSet();

  function cartChangeUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_change_url) || (root + 'cart/change.js');
  }

  function showCartGate(container) {
    var gate = container && container.querySelector('.ps-cart-gate, .lnec-checkout-gate');
    if (gate) gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('submit', function (event) {
    var blockedCart = event.target.closest('[data-sizing-blocked="true"]');
    var checkoutSubmit = event.submitter && (
      event.submitter.name === 'checkout' ||
      event.submitter.hasAttribute('data-sizing-checkout-locked')
    );
    if (!blockedCart || !checkoutSubmit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showCartGate(blockedCart);
  }, true);

  document.addEventListener('click', function (event) {
    var fixSizingLink = event.target.closest('[data-fix-sizing]');
    if (fixSizingLink) {
      event.preventDefault();
      if (pendingSizingFixes.has(fixSizingLink)) return;
      var destination = fixSizingLink.href;
      var lineKey = fixSizingLink.dataset.lineKey;
      if (!lineKey) {
        window.location.assign(destination);
        return;
      }

      pendingSizingFixes.add(fixSizingLink);
      fixSizingLink.setAttribute('aria-busy', 'true');
      fixSizingLink.setAttribute('aria-disabled', 'true');
      fixSizingLink.style.pointerEvents = 'none';
      var cartMutations = window.MinimogCartMutations;
      var mutationCommitted = false;
      var keepLocked = false;
      cartMutations.begin();
      cartMutations.enqueue(function () {
        if (cartMutations.requiresReload) {
          keepLocked = true;
          return;
        }
        return cartMutations.requestJSON(cartChangeUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        }, { mutation: true }).then(function (result) {
          if (!result.response.ok || result.payload.errors) throw new Error('Unable to remove item');
          mutationCommitted = true;
          keepLocked = true;
          window.location.assign(destination);
        });
      }).catch(function (error) {
          keepLocked = mutationCommitted || error.cartStateUncertain === true;
          if (keepLocked) {
            cartMutations.recover(error);
            return;
          }
          pendingSizingFixes.delete(fixSizingLink);
          fixSizingLink.removeAttribute('aria-busy');
          fixSizingLink.removeAttribute('aria-disabled');
          fixSizingLink.style.pointerEvents = '';
          fixSizingLink.textContent = 'Remove this item, then choose its size.';
        }).finally(function () {
          cartMutations.end(keepLocked || cartMutations.requiresReload);
        });
      return;
    }

    var lockedCheckout = event.target.closest('[data-sizing-checkout-locked]');
    if (!lockedCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showCartGate(lockedCheckout.closest('[data-sizing-blocked="true"]'));
  }, true);
})();
